"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const heartfilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-heartfilled` : '') + (description ? ` desc-heartfilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-heartfilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-heartfilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.8733 3.7911L11.9988 4.6913L11.1249 3.79095C9.77752 2.40188 7.86001 1.76369 5.97361 2.07925C4.08981 2.39436 2.47097 3.62139 1.62115 5.37325L1.51261 5.60972C0.552104 7.83644 0.966056 10.416 2.54762 12.1951L11.4378 21.7552C11.7412 22.0816 12.2572 22.0816 12.5607 21.7552L21.2825 12.3746C23.0674 10.5341 23.5114 7.71171 22.3772 5.37331L22.2529 5.13113C21.3634 3.49797 19.811 2.37804 18.0248 2.07925C16.1384 1.76369 14.2208 2.40188 12.8733 3.7911Z",
    fill: "inherit"
  }));
};
var _default = exports.default = heartfilled;